export default __webpack_public_path__ + "media/src/features/home-page-redesign/assets/googlePlayIcon-e8e03c52bd6c42451901311c9971d937.svg";